export default "__VITE_ASSET__DBOqYDb6__"